import script from "./MRD_RT_001.vue?vue&type=script&setup=true&lang=js"
export * from "./MRD_RT_001.vue?vue&type=script&setup=true&lang=js"

import "./MRD_RT_001.vue?vue&type=style&index=0&id=5b37ee64&lang=css"

const __exports__ = script;

export default __exports__